import axios from "axios";
import { Response } from "@/shared/models/Response";
import { SessionQuery } from "../models/SessionQuery";
import { SessionTemplatePagination } from "../models/SessionTemplatePagination";
import { SessionTemplate } from "../models/SessionTemplate";
import { SessionTemplateHeader } from "../models/SessionTemplateHeader";
import { AmountSessionsByCategory } from "../models/SessionAmountByCategory.model";
import { SessionTemplateWithChartPagination } from "../models/sessionTemplatePaginationWithChart.model";

export class SessionTemplateService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/session-templates`;
  }

  async getSessionTemplateById(
    id: string
  ): Promise<Response<SessionTemplate | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceUrl);
    return response.data;
  }

  async getSessionTemplatesByFilter(
    query: SessionQuery
  ): Promise<Response<SessionTemplatePagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async addSessionTemplate(
    sessionTemplate: SessionTemplate
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/add-session`;
    const response = await axios.post(serviceUrl, sessionTemplate);
    return response.data;
  }

  async checkIfSessionNameExists(name: string): Promise<Response<void>> {
    const serviceUrl = `${this.baseUrl}/exist-by-name`;
    const response = await axios.get(serviceUrl, { params: { name } });
    return response.data;
  }

  async updateSessionTemplate(
    id: string,
    sessionTemplate: SessionTemplate
  ): Promise<Response<void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceUrl, sessionTemplate);
    return response.data;
  }

  async getAllActiveSessionTemplates(): Promise<
    Response<SessionTemplateHeader[]>
  > {
    const serviceURL = `${this.baseUrl}/get-all-active-session-template`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getCharts(): Promise<Response<AmountSessionsByCategory[]>> {
    const serviceURL = `${this.baseUrl}/get-charts`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getSessionTemplatesWithFilter(
    query: SessionQuery
  ): Promise<Response<SessionTemplateWithChartPagination>> {
    const serviceURL = `${this.baseUrl}/find-with-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateStateSessionTemplateById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async deleteServiceTemp(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }
}
